import React from "react";
import { faArrowRight, faFistRaised } from "@fortawesome/free-solid-svg-icons";
import Button from "../common/Button";

const CallToAction = ({ handleGetStarted }) => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-dark-grey to-black relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0">
        <div className="absolute -right-32 -bottom-32 w-96 h-96 rounded-full bg-deep-red opacity-[0.02] blur-[120px]"></div>
        <div className="absolute -left-32 top-0 w-96 h-96 rounded-full bg-gold opacity-[0.02] blur-[120px]"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 max-w-6xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Create Your
              <span className="block text-gold">UFC Fantasy</span>
              Lineup
            </h2>

            <p className="text-white/80 text-lg sm:text-xl mb-8 leading-relaxed max-w-2xl lg:max-w-none">
              Build your perfect fighter lineup from upcoming UFC events and
              compete for glory.
            </p>

            <div className="flex justify-center lg:justify-start">
              <Button
                onClick={handleGetStarted}
                variant="primary"
                size="lg"
                icon={faArrowRight}
                iconPosition="right"
                className="shadow-xl"
              >
                Get Started
              </Button>
            </div>
          </div>

          {/* Preview card */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md">
              <div className="absolute inset-0 bg-gradient-to-br from-deep-red to-bright-red rounded-2xl -rotate-2 scale-105 opacity-10"></div>

              <div className="relative rounded-xl overflow-hidden bg-dark-grey/80 backdrop-blur-sm border border-white/10 shadow-2xl">
                {/* Header */}
                <div className="bg-gradient-to-r from-deep-red to-bright-red p-6">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center">
                      <div className="text-white font-bold text-xl">
                        Your Lineup
                      </div>
                    </div>
                    <div className="bg-white/20 px-3 py-1 rounded-full text-white text-sm font-medium">
                      LIVE
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="text-white font-bold text-2xl mb-1">
                    UFC 301
                  </div>
                  <div className="text-white/60 mb-6">
                    May 4, 2024 • Rio de Janeiro
                  </div>

                  <div className="space-y-4 mb-6">
                    {[
                      { name: "Alexandre Pantoja", points: 150, badge: "MAIN" },
                      { name: "Steve Erceg", points: 120, badge: "CO-MAIN" },
                      { name: "José Aldo", points: 100, badge: "LEGEND" },
                    ].map((fighter, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between bg-white/5 rounded-lg p-4 hover:bg-white/10 transition-colors"
                      >
                        <div className="flex items-center">
                          <div className="w-10 h-10 rounded-full bg-deep-red flex items-center justify-center text-white text-sm font-bold mr-4">
                            #{index + 1}
                          </div>
                          <div>
                            <div className="text-white font-medium">
                              {fighter.name}
                            </div>
                            <div className="text-white/60 text-sm">
                              {fighter.points} pts projected
                            </div>
                          </div>
                        </div>
                        <div className="text-gold text-xs font-bold px-2 py-1 bg-gold/20 rounded">
                          {fighter.badge}
                        </div>
                      </div>
                    ))}
                  </div>

                  <Button
                    variant="primary"
                    size="md"
                    className="w-full shadow-lg"
                    icon={faFistRaised}
                    iconPosition="left"
                  >
                    Submit Lineup
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
